module.exports = __webpack_public_path__ + "static/media/spinner-loading.b823b297.gif";